import {NonIndexRouteObject, RouteObject} from 'react-router';

interface Config {
  loginRoute?: Omit<NonIndexRouteObject, 'path'>;
  registerRoute?: Omit<NonIndexRouteObject, 'path'>;
  accountSettingsRoute?: Omit<NonIndexRouteObject, 'path'>;
}

export function authRoutes({
  loginRoute,
  registerRoute,
  accountSettingsRoute,
}: Config = {}): RouteObject[] {
  return [
    {
      path: '/register',
      ...(registerRoute ? registerRoute : defaultRegisterRoute),
    },
    {
      path: '/login/mobile',
      ...(loginRoute ? loginRoute : defaultMobileLoginRoute),
    },
    {
      path: '/login',
      ...(loginRoute ? loginRoute : defaultLoginRoute),
    },

    // {
    //   path: '/workspace/join/register',
    //   ...(registerRoute ? registerRoute : defaultRegisterRoute),
    // },
    // {
    //   path: '/workspace/join/login',
    //   ...(loginRoute ? loginRoute : defaultLoginRoute),
    // },
    {
      path: '/forgot-password',
      lazy: () => import('@common/auth/ui/forgot-password-page'),
    },
    {
      path: '/password/reset/:token',
      lazy: () => import('@common/auth/ui/reset-password-page'),
    },
    {
      path: '/account-settings',
      ...(accountSettingsRoute
        ? accountSettingsRoute
        : defaultAccountSettingsRoute),
    },
    {
      path: '/account-info',
      ...(accountSettingsRoute
        ? accountSettingsRoute
        : defaultAccountInfoRoute),
    },
  ];
}

const defaultLoginRoute: NonIndexRouteObject = {
  lazy: async () => {
    const {LoginPageWrapper: Component} =
      await import('@common/auth/ui/login-page-wrapper');
    return {Component};
  },
};

const defaultMobileLoginRoute: NonIndexRouteObject = {
  lazy: async () => {
    const {MobileLoginPageWrapper: Component} =
      await import('@common/auth/ui/mobile-login-page-wrapper');
    return {Component};
  },
};

const defaultRegisterRoute: NonIndexRouteObject = {
  lazy: async () => {
    const {RegisterPage: Component} =
      await import('@common/auth/ui/register-page');
    return {Component};
  },
};

const defaultAccountSettingsRoute: NonIndexRouteObject = {
  lazy: async () => {
    const {AccountSettingsPage: Component} =
      await import('@common/auth/ui/account-settings/account-settings-page');
    return {Component};
  },
};

const defaultAccountInfoRoute: NonIndexRouteObject = {
  lazy: async () => {
    const {AccountSettingsPage: Component} =
      await import('@common/auth/ui/account-info/account-info-page');
    return {Component};
  },
};
